import { ToggleGroup, ToggleGroupItem } from 'src/components/ui/toggle-group';
import { Controller } from 'react-hook-form';
import { useEffect } from 'react';
import { clsx } from 'clsx';
import { API_VERSION } from 'src/constants/api-routes';
import type { PersonaFieldProps } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/personaFieldProps';
import { getApiVersion } from 'src/utils/apiVersion';

// Keyed by the field's option keys.
export const ROLE_FIELD_EMOJI: Record<string, string> = {
  support: '🤝',
  sales: '💰',
  custom: '🌟',
};

export const RoleField = ({
  field,
  data,
  control,
  readonly,
  setValue,
  watch,
}: PersonaFieldProps<'pf_role'>) => {
  const fieldValue = watch('pf_role');
  const version = getApiVersion();
  const isV2 = version === API_VERSION.V2;

  useEffect(() => {
    if (readonly) {
      if (data) {
        setValue('pf_role', data);
        return;
      }
      if (field?.default_value?.value) {
        setValue('pf_role', field?.default_value?.value);
        return;
      }
    }

    if (fieldValue) {
      setValue('pf_role', fieldValue);
      return;
    }

    if (data) {
      setValue('pf_role', data);
      return;
    }
    if (field?.default_value?.value) {
      setValue('pf_role', field?.default_value?.value);
      return;
    }

    setValue('pf_role', '');
  }, [readonly, field, data]);

  const onClick = (key: string) => {
    setValue('pf_role_click_value', key);
  };

  return field?.options?.length ? (
    <Controller
      control={control}
      name="pf_role"
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <ToggleGroup
          className={clsx(
            'flex gap-1.5 justify-items-stretch items-stretch w-full',
            readonly && 'pointer-events-none',
          )}
          onValueChange={onChange}
          defaultValue={value}
          value={value}
          type="single"
        >
          {field.options.map((option) => {
            const isCustom = option.value === 'custom';

            if (isV2 && isCustom) {
              return null;
            }

            return (
              <ToggleGroupItem
                className={'flex flex-1 items-center justify-center'}
                key={option.key}
                value={option.value}
                onClick={() => {
                  onClick(option.key);
                }}
              >
                {ROLE_FIELD_EMOJI[option.key]
                  ? `${ROLE_FIELD_EMOJI[option.key]} ${option.value}`
                  : option.value}
              </ToggleGroupItem>
            );
          })}
        </ToggleGroup>
      )}
    />
  ) : null;
};
